import { useEffect, useMemo, useState } from 'react';
import apiClient from '../context/apiClient';

const defaultPaketPreise = {
  FS5: 950.0,
  FS5HT: 475.0,
  FSTA: 250.0,
  FSA: 110.0,
  FSTaxi: 475.0,
  FSTour: 950.0,
  FSTE: 950.0,
  FSTtT: 975.0,
  FSK: 975.0,
  FSKHT: 487.5,
  FSMod: 975.0,
  FSReise: 475.0,
  TB: 415.0,
  TBHT: 235.0,
  TBA: 55.0,
  TBReise: 415.0,
  FZ6: 415.0,
  FZ6HT: 235.0,
  FZ6A: 515.0,
  FZ6AHT: 235.0,
  FZ6AVorNach: 515.0,
  FZ6AHTVorNach: 235.0,
  FZ6AReise: 415.0,
  FS5VorNach: 950.0,
  FS5HTVorNach: 475.0,
  TBVorNach: 415.0,
  TBHTVorNach: 235.0,
  FSReiseH: 237.5,
  FZ6AReiseH: 207.5,
  TBReiseH: 207.5,
};

const defaultExcludedNames = [
  'Rolf, Volland',
  'Mark, Allison',
  'Josef, Haider',
  'Jan, Becker',
  'Alexander, Heel',
  'Mattias, Ekström',
  'Kai-Uwe, Jochims',
  'Christopher, Haase',
  'Marco, Werner',
  ', HaiderKEG1',
  ', HaiderKEG2',
  ', HaiderKEG3',
  ', TKL1',
  ', TKL2',
  ', TKL3',
  ', TKL4',
  ', TKL5',
  ', TKL6',
  ', TKL7',
  ', TKL8',
  ', Aushilfe AES 1',
  ', Aushilfe AES 2',
  ', Aushilfe AES 3',
  ', Aushilfe AES 4',
];

export default function useRules() {
  const [paketPreise, setPaketPreise] = useState(defaultPaketPreise);
  const [excludedNames, setExcludedNames] = useState(defaultExcludedNames);
  const [loadingRules, setLoadingRules] = useState(true);
  const [rulesError, setRulesError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setLoadingRules(true);
      setRulesError(null);
      try {
        const [preiseRes, excludedRes] = await Promise.all([
          apiClient.get('/api/utility/leistungspaketeRules', { withCredentials: true }),
          apiClient.get('/api/utility/externalEmployees', { withCredentials: true }),
        ]);

        if (!isMounted) return;

        const preise = preiseRes?.data && typeof preiseRes.data === 'object' ? preiseRes.data : null;
        const excluded = Array.isArray(excludedRes?.data) ? excludedRes.data : null;

        if (preise) setPaketPreise(preise);
        if (excluded) setExcludedNames(excluded);
      } catch (e) {
        if (!isMounted) return;
        setRulesError(e);
        // Keep defaults on error.
      } finally {
        if (isMounted) setLoadingRules(false);
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  const excludedSet = useMemo(() => new Set(excludedNames), [excludedNames]);

  return { paketPreise, excludedNames, excludedSet, loadingRules, rulesError };
}
